import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'
import {IAssets, IPosition} from '../types/portfolio'

export interface IWalletTransactions {
    user_id?: string
    wallet_id?: string
    action?: string
    coin?: string
    amount?: number
    balance_after?: number
    action_parent_id?: string
    extra?: string
    created_at?: string
}
export const getWalletTransactions = async (
    userId: string,
    current_page: number,
): Promise<ApiRes<IWalletTransactions[]>> => {
    return await apiGet(API_URL, `admin/wallet/transaction/${userId}?current_page=${current_page}&page_size=${10}`)
}
